import React from 'react';
import { CalendarDays, ArrowUpRight } from 'lucide-react';
import { ECHOES } from '../mock/mock';
import { PageHero } from './BuyABook';

const Echoes = () => {
  return (
    <div className="fade-in">
      <PageHero
        title="Echoes Of My Mind"
        subtitle="Thought-provoking reflections blending personal experience with philosophy, history, and science."
      />

      <section className="max-w-6xl mx-auto px-5 lg:px-8 py-16">
        <div className="grid md:grid-cols-3 gap-8">
          {ECHOES.map((e) => (
            <article
              key={e.title}
              className="group bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-500 hover:-translate-y-1 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={e.image}
                  alt={e.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-2 text-xs text-brand-brass">
                  <CalendarDays className="h-3.5 w-3.5" /> {e.date}
                </div>
                <h3 className="font-serif text-2xl font-bold text-brand-ink mt-3 group-hover:text-brand-brass transition-colors">
                  {e.title}
                </h3>
                <p className="text-sm text-brand-brown/80 mt-3 leading-relaxed">{e.excerpt}</p>
                <span className="inline-flex items-center gap-1 text-sm font-medium text-brand-gold mt-4 group-hover:gap-2 transition-all">
                  Read reflection <ArrowUpRight className="h-4 w-4" />
                </span>
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Echoes;
